export default __webpack_public_path__ + "assets/2aee5c46e8bb14113468d4004b692a18.svg";